window.addEventListener('DOMContentLoaded', () => {
	const benefits = document.querySelectorAll('.benefits .benefit-item')
	const imageDesktop = document.querySelectorAll(
		'.benefits .image-desktop .item-image'
	)
	benefits?.forEach(benefitItem => {
		benefitItem.addEventListener('mouseover', () => {
			removeActive(benefits, 'active')
			removeActive(imageDesktop, 'active')
			benefitItem.classList.add('active')
			const index = benefitItem.dataset.index

			const imageItem = document.querySelector(
				`.benefits .image-desktop .item-image[data-index='${index}']`
			)
			imageItem?.classList.add('active')
		})
	})

	function removeActive(els, className) {
		els.forEach(el => {
			el.classList.remove(className)
		})
	}
})
